
    document.addEventListener('DOMContentLoaded', function () {
      const setSquareImageHeight = () => {
        const heroSection = document.querySelector('.custom-hero');
        if (!heroSection) return;

        const contentElement = heroSection.querySelector('.custom-hero__content');
        const imageWrapper = heroSection.querySelector('.custom-hero__image-wrapper');

        if (window.innerWidth > 768) {
          // On desktop: Make image wrapper same height as content
          const contentHeight = contentElement.offsetHeight;
          imageWrapper.style.height = `${contentHeight}px`;

          // Adjust aspect ratio
          if (contentHeight > 0) {
            imageWrapper.style.aspectRatio = 'auto';
          }
        } else {
          // On mobile: Set to a square aspect ratio
          imageWrapper.style.height = 'auto';
          imageWrapper.style.aspectRatio = '1';
        }
      };

      // Run on load and resize
      setSquareImageHeight();
      window.addEventListener('resize', setSquareImageHeight);

      // Also run after a short delay to handle any dynamic content loading
      setTimeout(setSquareImageHeight, 500);
    });
  
;

  // Run immediately to prevent any flash of video controls
  (function () {
    function hideVideoControls() {
      const videos = document.querySelectorAll('.custom-hero__video');
      videos.forEach(function (video) {
        video.removeAttribute('controls');
        video.controls = false;
        // Additional properties to ensure controls stay hidden
        video.style.setProperty('-webkit-appearance', 'none', 'important');
        video.style.setProperty('-moz-appearance', 'none', 'important');
        video.style.setProperty('appearance', 'none', 'important');
      });
    }

    // Run immediately if elements exist
    hideVideoControls();

    // Also run on DOM ready as backup
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hideVideoControls);
    } else {
      hideVideoControls();
    }
  })();

;

  document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('.custom-hero__video');

    // Immediately remove any controls attribute to prevent flash of controls
    videos.forEach(function (video) {
      video.removeAttribute('controls');
      video.controls = false;
    });

    videos.forEach(function (video) {
      const container = video.closest('.custom-hero__video-container');
      let hasLoaded = false;

      // Set a timeout to show fallback if video takes too long to load (2 seconds)
      const loadTimeout = setTimeout(function () {
        if (!hasLoaded && container) {
          console.log('Video loading timeout - showing fallback image');
          container.classList.add('video-error');
        }
      }, 2000);

      // Handle successful video loading
      function handleVideoLoaded() {
        if (!hasLoaded) {
          hasLoaded = true;
          clearTimeout(loadTimeout);
          video.classList.add('loaded');
          if (container) {
            container.classList.add('video-loaded');
          }
          console.log('Video loaded successfully');
        }
      }

      // Handle video loading error
      function handleVideoError() {
        console.log('Video failed to load - showing fallback image');
        clearTimeout(loadTimeout);
        if (container) {
          container.classList.add('video-error');
        }
      }

      // Add event listeners
      video.addEventListener('loadeddata', handleVideoLoaded);
      video.addEventListener('canplay', handleVideoLoaded);
      video.addEventListener('canplaythrough', handleVideoLoaded);
      video.addEventListener('error', handleVideoError);

      // Check if video is already loaded (in case events fired before we attached listeners)
      if (video.readyState >= 3) {
        // HAVE_FUTURE_DATA or higher
        handleVideoLoaded();
      }

      // Handle autoplay failure (some browsers block autoplay)
      video.addEventListener('loadedmetadata', function () {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(function (error) {
            console.log('Autoplay failed, but video loaded successfully');
            // Don't show error state if autoplay fails but video loaded
            handleVideoLoaded();
          });
        }
      });

      // Additional fallback: If video doesn't start playing within 4 seconds, show fallback
      setTimeout(function () {
        if (!hasLoaded && video.currentTime === 0 && container) {
          console.log('Video failed to start playing - showing fallback image');
          container.classList.add('video-error');
        }
      }, 4000);
    });
  });
